/* src/app/components/control-module/control-module-header/control-module-header.component.css */
@media (max-width: 1400px) {
  .ps-nav {
    padding-left: 10px !important;
    padding-right: 8px !important;
  }
}
.fusion-brand {
  display: flex;
  align-items: center;
  padding: 0 16px 0 0;
  flex-shrink: 0;
  text-decoration: none;
  cursor: pointer;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
  margin-right: 16px !important;
}
@media (max-width: 1400px) {
  .brand-logo-wrap img {
    height: 40px !important;
  }
}
.mobile-toggler-btn {
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  padding: 6px 10px !important;
  background: rgba(255, 255, 255, 0.05) !important;
  transition: background 0.15s;
  line-height: 1;
}
@keyframes mobileNavIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.mobile-nav-overlay {
  position: fixed;
  top: 74px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1009;
}
.mobile-nav-panel {
  background: var(--navy-900);
  border-bottom: 2px solid rgba(255, 255, 255, 0.08);
  max-height: calc(100vh - 74px);
  overflow-y: auto;
  animation: mobileNavIn 0.22s ease;
}
.mobile-nav-link {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 15px 20px;
  color: rgba(255, 255, 255, 0.82) !important;
  font-size: 1em;
  font-weight: 500;
  text-decoration: none;
  background: transparent;
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  cursor: pointer;
  transition: background 0.14s, color 0.14s;
  text-align: left;
}
.mobile-nav-submenu {
  background: rgba(0, 0, 0, 0.18);
}
.mobile-nav-footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  padding: 12px 16px 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.15);
}
.mobile-lang-group {
  display: flex;
  align-items: center;
  margin-right: 6px;
}
.mobile-footer-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--radius-xs);
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  padding: 7px 10px;
  font-size: 0.9em;
  transition: background 0.13s, color 0.13s;
  position: relative;
}
.mobile-logout-btn {
  margin-left: auto;
  color: rgba(255, 120, 120, 0.85);
  border-color: rgba(255, 100, 100, 0.2);
}
.mobile-footer-label {
  white-space: nowrap;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}
/*# sourceMappingURL=control-module-header.component.css.map */
